"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.INVENTORY_OVERVIEW = void 0;
var INVENTORY_OVERVIEW = {
  TEXT__STOCK: 'inventoryOverview-span-stock',
  TEXT__DATE_CREATED: 'inventoryOverview-span-dateCreated',
  TEXT__WAREHOUSE: 'inventoryOverview-span-warehouse',
  TEXT__LOCATION: 'inventoryOverview-span-location',
  TEXT__BATCH_CODE: 'inventoryOverview-span-batchCode',
  TEXT__EXPIRY_DATE: 'inventoryOverview-span-expiryDate',
  TEXT__COGS: 'inventoryOverview-span-cogs',
  BUTTON__EDIT: 'inventoryOverview-button-edit',
  EDIT_BATCH_DETAILS_MODAL: {
    INPUT__BATCH_CODE: 'editBatchDetailsModal-input-batchCode',
    INPUT__EXPIRY_DATE: 'editBatchDetailsModal-input-epiryDate',
    INPUT__COGS: 'editBatchDetailsModal-input-cogs',
    BUTTON__SAVE: 'editBatchDetailsModal-button-save'
  }
};
exports.INVENTORY_OVERVIEW = INVENTORY_OVERVIEW;